class CartRecommendations extends HTMLElement {
  connectedCallback() {
    this.fetchRecommendations();
  }

  async fetchRecommendations() {
    const productId = this.dataset.productId;
    if (!productId) return;

    const limit = this.dataset.limit || 4;
    const intent = this.dataset.intent || 'related';
    const url = `${this.dataset.url}?section_id=cart-recommendations&product_id=${productId}&limit=${limit}&intent=${intent}`;

    try {
      const res = await fetch(url);
      const html = await res.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const content = doc.querySelector('.cart-recommendations__inner');
      if (content) {
        this.innerHTML = '';
        this.appendChild(content);
      } else {
        this.innerHTML = '';
      }
    } catch (err) {
      console.error('[cart-recommendations] Failed to load recommendations:', err);
    }
  }
}

customElements.define('cart-recommendations', CartRecommendations);